import React, { FC } from 'react';


interface DateIconProps {
  className?: string;
}

const DateIcon: FC<DateIconProps> = ({
  className,
}) => {
  return (
     <svg
                      className={className}
                      width="25"
                      height="25"
                      viewBox="0 0 25 25"
                      fill="none"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        d="M9.88965 11.5508H7.88965V13.5508H9.88965V11.5508ZM13.8896 11.5508H11.8896V13.5508H13.8896V11.5508ZM17.8896 11.5508H15.8896V13.5508H17.8896V11.5508ZM19.8896 4.55078H18.8896V2.55078H16.8896V4.55078H8.88965V2.55078H6.88965V4.55078H5.88965C4.78965 4.55078 3.88965 5.45078 3.88965 6.55078V20.5508C3.88965 21.6508 4.78965 22.5508 5.88965 22.5508H19.8896C20.9896 22.5508 21.8896 21.6508 21.8896 20.5508V6.55078C21.8896 5.45078 20.9896 4.55078 19.8896 4.55078ZM19.8896 20.5508H5.88965V9.55078H19.8896V20.5508Z"
                        fill="currentColor"
                      />
                    </svg>
  );
};



export default DateIcon;
